import classNames from 'classnames';
import React from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';

import styles from './indicatorCheckbox.scss';

interface IndicatorCheckboxProps {
  containerStyles?: string;
  isSelected?: boolean;
  shouldRender?: boolean;
}

export default function IndicatorCheckbox({
  containerStyles,
  isSelected,
  shouldRender = true
}: IndicatorCheckboxProps) {
  if (!shouldRender) return null;
  const mainContainerStyles = classNames(
    styles.indicatorCheckboxContainer,
    containerStyles,
    'indicatorCheckbox',
    {
      [styles.indicatorCheckboxContainer_isSelected]: isSelected
    }
  );
  const checkmarkStyles = classNames(styles.checkmark, {
    [styles.checkmark_isSelected]: isSelected
  });

  return (
    <div aria-hidden className={mainContainerStyles}>
      <Icon type={ICON_TYPES.CHECKBOX} containerStyles={checkmarkStyles} />
    </div>
  );
}
